import React, { useContext } from 'react';
import HeaderContext, { HeaderContextInterface } from '../../HeaderContext';
import { Home } from './Home';
import { Dashboard } from './Dashboard';
import { MySurveys } from './MySurveys';
import { Pricing } from './Pricing';
import { TeamMenu } from './TeamMenu';
import { DataStudio } from './DataStudio';
import { StaticContext } from '../../../../StaticContext';

const BaseMenu = ({
  experiment,
}: {
  experiment: Record<string, any> | undefined;
}): JSX.Element => {
  const headerContext = useContext<HeaderContextInterface>(HeaderContext);
  // Global Header experiment
  // https://momentiveai.atlassian.net/browse/HOME-737
  const lihpTreatment = experiment?.lihpHeader?.treatment;
  const { homePageEnabled, hasLIHPFeature, hasSeenLIHPWelcomeModal } =
    headerContext?.user ?? {};
  const hasLIHPTreatment = [
    'has_lihp',
    'lihp_paid_individuals_treatment',
    'lihp_teams_treatment',
    'lihp_sme_treatment',
  ].includes(lihpTreatment);

  // Global Header experiment for EAP Users
  // https://surveymonkey.atlassian.net/browse/AN-2776
  // https://admin.surveymonkey.com/experiments/surveymonkey/2439
  const { HEADER_EXP = {} } = useContext(StaticContext);
  const EAPExperimentTreatment = HEADER_EXP?.isEAPUser?.treatment;
  const hasEAPEntryPointExperiment =
    EAPExperimentTreatment === 'analyze_workspaces_button_treatment';

  return (
    <>
      {homePageEnabled !== false &&
      (hasLIHPFeature || hasSeenLIHPWelcomeModal || hasLIHPTreatment) ? (
        <Home key="menu-home" />
      ) : (
        <>
          <Dashboard key="menu-dashboard" />
          <MySurveys key="menu-surveys" />
        </>
      )}
      <TeamMenu key="menu-team" />
      <Pricing key="menu-pricing" />
      {hasEAPEntryPointExperiment && <DataStudio key="menu-data-studio" />}
    </>
  );
};

export default BaseMenu;
